// /api/settings/a2p — front-end API helpers for the auto-A2P page.
// Mirrors the routes registered in api/src/routes/settingsA2p.js.

import { apiGet, apiPost, apiDel } from '../lib/api.js';

export const fetchBrand = () => apiGet('/settings/a2p/brand');
export const fetchCapacity = () => apiGet('/settings/a2p/capacity');
export const fetchCampaigns = () => apiGet('/settings/a2p/campaigns');
export const fetchCampaign = (id) => apiGet(`/settings/a2p/campaigns/${id}`);
export const fetchCatalog = () => apiGet('/settings/a2p/catalog');

export const submitCampaign = (payload) =>
  apiPost('/settings/a2p/campaigns', payload);

export const regeneratePasscode = (id) =>
  apiPost(`/settings/a2p/campaigns/${id}/regenerate-passcode`);

export const deleteCampaign = (id) =>
  apiDel(`/settings/a2p/campaigns/${id}`);

export const joinCampaign = (id) =>
  apiPost(`/settings/a2p/campaigns/${id}/join`);

export const refreshCampaign = (id) =>
  apiPost(`/settings/a2p/campaigns/${id}/refresh`);

// Capacity-meter color thresholds (mirrors capacityService.bannerLevel).
export const CAMPAIGN_CAPACITY = 49;
export const BANNER_WARN_PCT = 80;
export const BANNER_CRIT_PCT = 95;

export function bannerLevel(pct) {
  if (pct >= BANNER_CRIT_PCT) return 'critical';
  if (pct >= BANNER_WARN_PCT) return 'warning';
  if (pct >= 50) return 'caution';
  return 'ok';
}
